<template>
  <div class="deviation-container">
    <header class="modal-card-head">
      <div class="columns">
        <div class="column">
          <b-field :label="$t('deviation_report.unit_serial')">
            <b-input v-model="job.serialNumber" :disabled="true" />
          </b-field>
        </div>
        <div class="column dij-deviation-radio">
          <b-radio
            v-model="radio"
            name="radio"
            :native-value="'review_only'"
            :disabled="isReadonly"
            @input="save"
          >
            {{ $t('deviation_report.review_only') }}
          </b-radio>
          <b-radio
            v-model="radio"
            name="radio"
            :native-value="'action_required'"
            :disabled="isReadonly"
            @input="save"
          >
            {{ $t('deviation_report.action_required') }}
          </b-radio>
        </div>
      </div>
    </header>
    <b-table :data="deviationRows">
      <template #empty>
        <div class="has-text-centered">{{ $t('report_tasks.no_records') }}</div>
      </template>
      <template slot-scope="props">
        <template v-if="props.row.id === editFieldId">
          <b-table-column
            field="assemblyBOM"
            :label="$t('deviation_report.assembly_bom')"
          >
            <b-input v-model="props.row.assemblyBOM" />
          </b-table-column>

          <b-table-column
            field="assemblyRef"
            :label="$t('deviation_report.assembly_ref')"
          >
            <b-input v-model="props.row.assemblyRef" />
          </b-table-column>

          <b-table-column
            field="itemNumber"
            :label="$t('deviation_report.item_number')"
          >
            <b-input v-model="props.row.itemNumber" />
          </b-table-column>

          <b-table-column
            field="originalPn"
            :label="$t('deviation_report.original_pn')"
          >
            <b-input v-model="props.row.originalPn" />
          </b-table-column>

          <b-table-column
            field="description"
            :label="$t('report_tasks.description_uc')"
          >
            <b-input v-model="props.row.description" type="textarea" />
          </b-table-column>
          <b-table-column :label="$t('deviation_report.actions')">
            <b-button @click="save" type="is-success">
              {{ $t('save') }}
            </b-button>
          </b-table-column>
        </template>

        <template v-else>
          <b-table-column
            field="assemblyBOM"
            :label="$t('deviation_report.assembly_bom')"
          >
            {{ props.row.assemblyBOM }}
          </b-table-column>

          <b-table-column
            field="assemblyRef"
            :label="$t('deviation_report.assembly_ref')"
          >
            {{ props.row.assemblyRef }}
          </b-table-column>

          <b-table-column
            field="itemNumber"
            :label="$t('deviation_report.item_number')"
          >
            {{ props.row.itemNumber }}
          </b-table-column>

          <b-table-column
            field="originalPn"
            :label="$t('deviation_report.original_pn')"
          >
            {{ props.row.originalPn }}
          </b-table-column>

          <b-table-column
            field="description"
            :label="$t('report_tasks.description_uc')"
          >
            {{ props.row.description }}
          </b-table-column>
          <b-table-column
            :label="$t('deviation_report.actions')"
            v-if="!isReadonly"
          >
            <b-button
              type="is-info"
              icon-left="pencil"
              @click="editRow(props.row.id)"
              >{{ $t('edit') }}</b-button
            >
            <b-button
              style="margin-left: 10px"
              type="is-danger"
              icon-right="delete"
              @click="deleteRow(props.row.id)"
            />
          </b-table-column>
        </template>
      </template>
    </b-table>
  </div>
</template>

<script>
import { v4 } from 'uuid';

const uuidv4 = v4;

export default {
  name: 'DeviationReport',
  props: {
    isReadonly: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    job() {
      return this.$store.state.currentJob;
    },

    deviationRows() {
      if (!this.job.deviationReport) return [...this.newRows];
      return [...this.job.deviationReport.rows, ...this.newRows];
    },
  },

  watch: {
    job() {
      this.newRows = [];
    },
  },

  data() {
    return {
      assemblyBOM: '',
      assemblyRef: '',
      itemNumber: '',
      originalPn: '',
      description: '',
      editFieldId: null,
      newRows: [],
      serialNumber: '',
      deviationType: '',
      radio: '',
    };
  },

  mounted() {
    this.radio = this.job.deviationReport.radio;
  },

  methods: {
    addRow() {
      const newRow = {
        id: uuidv4(),
        assemblyBOM: '',
        assemblyRef: '',
        itemNumber: '',
        originalPn: '',
        description: '',
      };
      this.editFieldId = newRow.id;
      this.newRows.push(newRow);
    },

    async save() {
      this.editFieldId = null;
      const updatedJob = { ...this.job };
      const { radio } = this;
      const rows = this.deviationRows;
      updatedJob.deviationReport = {
        radio,
        rows,
      };
      this.newRows = [];
      await this.$store.dispatch('updateJobSimple', updatedJob);
    },

    async deleteRow(id) {
      this.editFieldId = null;
      const updatedJob = { ...this.job };
      const { radio } = this;
      const rows = this.deviationRows.filter((row) => row.id !== id);
      updatedJob.deviationReport = {
        radio,
        rows,
      };
      this.newRows = [];
      await this.$store.dispatch('updateJobSimple', updatedJob);
    },

    editRow(id) {
      this.editFieldId = id;
    },
  },
};
</script>

<style scoped lang="scss">
.deviation-container {
  background-color: #fff;
  width: 100%;
}
.modal-cars-header {
  padding: 10px;
}
.modal-card-head {
  background-color: #fff;
}
.dij-deviation-radio {
  flex-direction: column;
  display: flex;
  justify-content: space-evenly;
  padding: 10px;
}
.empty-header {
  display: flex;
  justify-content: space-between;
}
</style>
